module.exports = __webpack_public_path__ + "SC05_Guest.0b1e257e.json";